// extracted by mini-css-extract-plugin
module.exports = {"root":"List_root__3rivS"};